export default "__VITE_ASSET__8cc476ee__"